@if (!readonly) {
  <div #container class="floating-label-container" style="width: 100%">
    <div
      style="
        position: relative;
        width: 100%;
        align-items: center;
        border: 1px solid #dddddd;
        border-radius: 4px;
        padding: 6px 4px 7px 4px;
      "
    >
      <input
        type="date"
        #inputControl
        class="floatText"
        style="width: 100%"
        [value]="boundValue || ''"
        (input)="_handle_change($event)"
        (blur)="_handle_onBlur($event)"
      />
    </div>
    <div [class]="label ? 'floatLabel' : ''">{{ label }}</div>
  </div>
}

@if (readonly) {
  <div #container class="floating-label-container" style="width: 100%">
    <div
      style="
        position: relative;
        width: 100%;
        align-items: center;
        border: 1px solid #dddddd;
        border-radius: 4px;
        padding: 6px 4px 7px 4px;
      "
    >
      <input
        [readonly]="true"
        type="date"
        #inputControl
        class="floatText"
        style="width: 100%"
        [value]="boundValue || ''"
        (input)="_handle_change($event)"
        (blur)="_handle_onBlur($event)"
      />
    </div>
    <div [class]="label ? 'floatLabel' : ''">{{ label }}</div>
  </div>
}
